export const ooredooSelect = (select, options) => {

    if (typeof options === 'undefined') {
        options = {};
    }

    if (typeof select.data('searchable') !== 'undefined') {
        options.searchable = select.data('searchable') === true;
    }

    const triggerEvent = function (type) {
        select.trigger(`odsSelect:${type}`);
    }

    const extractElProps = (element, addToElement) => {
        let attributes = element[0].attributes;
        let props = [];
        for (let i = 0; i < attributes.length; ++i) {
            props.push(attributes[i]);

            if (addToElement && addToElement.length) {

                if (element[0].tagName.toLowerCase() === 'option' && attributes[i].name.toLowerCase() === 'selected') {
                    continue;
                }
                addToElement.attr(attributes[i].name, attributes[i].value);
            }
        }

        return props;
    }

    const fixWrapperWidth = function (selectWrapper) {
        let dataWidth = selectWrapper.attr('data-default_width');
        if (typeof dataWidth === 'undefined') {
            dataWidth = parseFloat(selectWrapper.width());
            selectWrapper.attr('data-default_width', dataWidth)
        }
        dataWidth = parseFloat(dataWidth);
        selectWrapper.css('width', 'auto');
        selectWrapper.find('.os__selected-item__list').css('width', 'auto');
        let itemWidth = parseFloat(selectWrapper.find('.os__selected-item__list').width()) + 64;


        if (itemWidth > dataWidth) {
            selectWrapper.css('width', itemWidth);
        } else {
            selectWrapper.css('width', dataWidth);
        }
        selectWrapper.find('.os__selected-item__list').css('width', '');
    }

    const toggleItemsVisibility = function (selectWrapper, showRestGroupsOnly = false) {

        const selectItems = selectWrapper.find('.ooredoo-ods-select');

        if (true === showRestGroupsOnly && selectItems.find('.ooredoo-ods-select__option-group').length) {
            // console.log('showRestGroupsOnly', showRestGroupsOnly)
            return false;
        }
        if (selectItems.hasClass('is-opened')) {
            selectItems.removeClass('is-opened');
            triggerEvent('closed');

            selectWrapper.css('zIndex', '');
            if (typeof options.onCloseItemsList === 'function') {
                options.onCloseItemsList(selectWrapper, selectItems);
            }
        } else {
            selectItems.addClass('is-opened');
            triggerEvent('opened');

            selectWrapper.css('zIndex', '99999999');
            if (typeof options.onOpenItemsList === 'function') {
                options.onOpenItemsList(selectWrapper, selectItems);
            }

        }

    }

    var normalize_text = function (text) {

        //remove special characters
        text = text.replace(/([^\u0621-\u063A\u0641-\u064A\u0660-\u0669a-zA-Z 0-9])/g, '');

        //normalize Arabic
        text = text.replace(/(آ|إ|أ)/g, 'ا');
        text = text.replace(/(ة)/g, 'ه');
        text = text.replace(/(ئ|ؤ)/g, 'ء')
        text = text.replace(/(ى)/g, 'ي');

        //convert arabic numerals to english counterparts.
        var starter = 0x660;
        for (var i = 0; i < 10; i++) {
            text.replace(String.fromCharCode(starter + i), String.fromCharCode(48 + i));
        }

        return text;
    }

    const filterOptions = function (selectWrapper) {
        const searchInput = selectWrapper.find('.ooredoo-ods-select__search-input');
        const selectItems = selectWrapper.find('.ooredoo-ods-select__items__inner');

        let val = searchInput.val().trim();
        if (!val.length) {
            selectItems.find('.ooredoo-ods-select__option').removeClass('is-hidden-option');
        } else {
            $.each(selectItems.find('.ooredoo-ods-select__option'), function (idx, el) {
                let text = $(el).text();
                val = normalize_text(val);
                text = normalize_text(text);
                let isNotValid = text.indexOf(val) === -1 && $(el).attr('value').toLowerCase().indexOf(val.toLowerCase()) === -1;

                if (isNotValid) {
                    $(this).addClass('is-hidden-option');
                } else {
                    $(this).removeClass('is-hidden-option');
                }
            });
        }
        if (!selectItems.find('.ooredoo-ods-select__option:not(.is-hidden-option)').length) {
            selectWrapper.find('.ooredoo-ods-select__search-no-results').stop().fadeIn('fast');
        } else {
            selectWrapper.find('.ooredoo-ods-select__search-no-results').stop().fadeOut('fast');
        }
    }

    const checkSelectedVal = function (select) {
        const _wrapper = select.closest('.ooredoo-ods-select-wrapper');
        const selectedValues = _wrapper.find('.ooredoo-ods-select__items .ooredoo-ods-select__option:not(.empty-value)[selected]');
        const hasSelected = selectedValues.length;
        if (hasSelected) {
            _wrapper.find('.ooredoo-ods-select__selected-item').addClass('selected--value');
        } else {
            _wrapper.find('.ooredoo-ods-select__selected-item').removeClass('selected--value');
        }

        $.each(selectedValues, function (idx, optn) {
            if ($(optn).closest('.ooredoo-ods-select__option-group').length) {
                toggleOptionGroup($(optn).closest('.ooredoo-ods-select__option-group'));
                $(optn).append('<i class="optn__close_icon icon-Icon-112"></i>')
            }
        });

    }

    const showAllOptionGroups = function (root) {
        root.find('.ooredoo-ods-select__option-group').removeClass('is-hidden-group');
        root.find('.ooredoo-ods-select__option-group').removeClass('is-opened');
    }
    const toggleOptionGroup = function (clickedGroup) {
        const itemsRoot = clickedGroup.closest('.ooredoo-ods-select__items__inner');
        const groups = itemsRoot.find('.ooredoo-ods-select__option-group');

        $.each(groups, function (idx, gr) {
            $(gr).removeClass('is-opened');
            $(gr).addClass('is-hidden-group');
        });

        clickedGroup.addClass('is-opened');
        clickedGroup.removeClass('is-hidden-group');

        const emptyVal = itemsRoot.find('.ooredoo-ods-select__option.empty-value');
        if (emptyVal.length) {
            if (itemsRoot.find('.ooredoo-ods-select__option-group.is-opened').length) {
                if (!emptyVal.closest('.ooredoo-ods-select__option-group').length) {
                    emptyVal.addClass('is-hidden-option');
                }
            } else {
                emptyVal.removeClass('is-hidden-option');
            }

        }

    }
    const onSelectValue = function (select, optn) {
        const _wrapper = select.closest('.ooredoo-ods-select-wrapper');

        checkSelectedVal(select);

        if (!optn.hasClass('empty-value')) {
            let emptyVal = select.find('.ooredoo-ods-select__option.empty-value');
            emptyVal.attr('selected', '');
        }

        const optnGroup = optn.closest('.ooredoo-ods-select__option-group');
        let value = optn.attr('value');

        let showRestGroupsOnly = false;

        if (optnGroup.length) {
            if (optnGroup.find('.ooredoo-ods-select__option[selected]').attr('value') === optn.attr('value')) {
                toggleOptionGroup(optnGroup);
                showRestGroupsOnly = true;
            }
        }

        let currentVal = select.val();
        select.val(value);

        if (value !== currentVal) {
            select.trigger('change');
        }

        toggleItemsVisibility(_wrapper, showRestGroupsOnly);
        fixWrapperWidth(_wrapper);
        if (options.searchable) {
            filterOptions(_wrapper);
        }

    }

    const ooredooSelectSpreedItems = (selectWrapper) => {
        const select = selectWrapper.find('select').first();
        const selectItems = selectWrapper.find('.ooredoo-ods-select__items__inner');
        const selectedItem = selectWrapper.find('.ooredoo-ods-select__selected-item').find('.os__selected-item__list');

        selectItems.empty();
        selectedItem.empty();
        let selectedValues = select.val();

        if (!Array.isArray(selectedValues)) {
            if (null === selectedValues) {
                selectedValues = '';
            }
            selectedValues = [selectedValues.toString().trim()];
        }

        selectedValues = selectedValues.filter(function (el) {
            return el != null && el != '';

        });

        if (select.find('optgroup').length) {

        }

        let optionsList = {};
        if (select.attr('name') == 'shipping_method[shipping_method_exhibition]') {
            $.each(select.find('optgroup,option'), function (idx, opt) {
                if (opt.tagName.toLowerCase() === 'optgroup') {
                    let _groupKey = $(opt).attr('label');
                    if ($(opt).attr('data-id')) {
                        _groupKey = $(opt).attr('data-id');
                    }
                    _groupKey = opt.tagName.toLowerCase() + '_' + _groupKey;
                    optionsList[_groupKey] = {
                        option_group: opt,
                        options: [],
                    };
                } else {
                    let parent = $(opt).closest('optgroup');
                    if (parent.length) {
                        let _groupKey = $(parent).attr('label');
                        if ($(parent).attr('data-id')) {
                            _groupKey = $(parent).attr('data-id');
                        }
                        _groupKey = parent[0].tagName.toLowerCase() + '_' + _groupKey;

                        optionsList[_groupKey].options.push($(opt));
                    } else {
                        let key = opt.tagName.toLowerCase() + '_' + $(opt).attr('value').trim();
                        if ($(opt).attr('value').trim() == '') {
                            key = opt.tagName.toLowerCase() + '_empty_option';
                        }
                        optionsList[key] = {
                            option_group: false,
                            options: [
                                $(opt)
                            ],
                        };
                    }
                }
            });
            $.each(optionsList, function (idx, list) {
                let parent = null;
                let parentInner = null;

                if (list.option_group) {
                    parent = $(`<div class="ooredoo-ods-select__option-group"><div class="ooredoo-ods-select__option-group__title">${$(list.option_group).attr('label')}</div></div>`);
                    parentInner = $(`<div class="ooredoo-ods-select__option-group__options"></div>`);
                    parent.append(parentInner);
                    extractElProps($(list.option_group), parent);
                    selectItems.append(parent);
                    parent.on('click', function (e) {
                        e.preventDefault();
                        e.stopPropagation();
                        toggleOptionGroup($(this));
                    });
                }

                $.each(list.options, function (idx, opt) {
                    let optHtml = $(`<div class="ooredoo-ods-select__option">${$(opt).html()}</div>`);

                    extractElProps($(opt), optHtml);
                    if (parentInner) {
                        parentInner.append(optHtml);
                    } else {
                        selectItems.append(optHtml);
                    }

                    let optnVal = $(opt).attr('value').toString();

                    let index = selectedValues.indexOf(optnVal);
                    if ((index !== -1 && typeof selectedValues[index] !== 'undefined' && selectedValues[index].length && selectedValues[index] === optnVal) || (!selectedValues.length && optnVal === '')) {
                        optHtml.attr('selected', 'selected');
                        selectedItem.html(`<div class="os__selected-item__option">${$(opt).html()}</div>`);
                    }
                    if (optnVal === '') {
                        optHtml.addClass('empty-value');

                    }
                    optHtml.on('click', function (e) {
                        e.stopPropagation();
                        if (selectItems.find('.ooredoo-ods-select__option-group').length) {
                            if (this.getAttributeNames().indexOf('selected') !== -1) {
                                showAllOptionGroups($(this).closest('.ooredoo-ods-select__items'));
                                return;
                            }
                        }
                        onSelectValue(select, $(this));
                    });

                });

            });
            checkSelectedVal(select);
            return;
        }


        $.each(select.find('option'), function (idx, opt) {

            let optHtml = $(`<div class="ooredoo-ods-select__option">${$(opt).html()}</div>`);
            extractElProps($(opt), optHtml);
            selectItems.append(optHtml);
            let optnVal = $(opt).attr('value').toString();

            // let index = optnVal.indexOf(selectedValues);
            let index = selectedValues.indexOf(optnVal);
            // let idx2 = selectedValues.findIndex(function (v) {
            //     return v === optnVal;
            // });

            if ((index !== -1 && typeof selectedValues[index] !== 'undefined' && selectedValues[index].length && selectedValues[index] === optnVal) || (!selectedValues.length && optnVal === '')) {
                optHtml.attr('selected', 'selected');
                selectedItem.html(`<div class="os__selected-item__option">${$(opt).html()}</div>`);
            }
            if (optnVal === '') {
                optHtml.addClass('empty-value');
            }
            optHtml.on('click', function (e) {
                onSelectValue(select, $(this));
            });
        });

        checkSelectedVal(select);
    };

    return new Promise((resolve) => {
        select = $(select);
        let selectWrapper = select.closest('.ooredoo-ods-select-wrapper');

        if (!selectWrapper.length) {
            selectWrapper = $('<div class="ooredoo-ods-select-wrapper"></div>');
            let icon = 'icon-Icon-09';
            if (typeof select.data('select_icon') !== 'undefined') {
                icon = select.data('select_icon');
            }
            icon = `<i class="${icon}"></i>`;
            const selectElement = $('<div class="ooredoo-ods-select"></div>');
            const selectedItem = $(`<div class="ooredoo-ods-select__selected-item"><span class="ooredoo-ods-select-arrow">${icon}</span><div class="os__selected-item__list"></div></div>`);
            const selectItems = $('<div class="ooredoo-ods-select__items"><div class="ooredoo-ods-select__items__inner"></div></div>');

            selectElement.append(selectedItem);
            selectElement.append(selectItems);
            selectWrapper.append(selectElement);

            if (options.searchable) {
                if (options.searchable === true) {
                    selectItems.prepend(`<div class="ooredoo-ods-select__search-wrapper">
<div class="ooredoo-ods-select__search-elements">
<input class="form-control ooredoo-ods-select__search-input" placeholder="${window.ooredoo_app.translations.select_search_hint}"/>
<i class="icon-search"></i>
</div>
<div class="ooredoo-ods-select__search-no-results" style="display: none;">${window.ooredoo_app.translations.select_search_no_result}</div>
</div>`);

                }

                let typingTimer;                //timer identifier
                let doneTypingInterval = 500;  //time in ms, 5 second for example

                selectWrapper.on('keyup', '.ooredoo-ods-select__search-input', function (e) {
                    const me = $(this);
                    clearTimeout(typingTimer);

                    typingTimer = setTimeout(function () {
                        filterOptions(selectWrapper);
                    }, doneTypingInterval);

                });
                selectWrapper.on('keydown', '.ooredoo-ods-select__search-input', function (e) {
                    // console.log('keydown')
                    clearTimeout(typingTimer);
                });

            }

            select.after(selectWrapper);
            selectWrapper.append(select);
            extractElProps(select, selectElement);

            selectElement.attr('class', 'ooredoo-ods-select');

            select.addClass('ooredoo-ods-select-initialized ooredoo-ods-select-hidden');
            let sTheme = 'default';
            if (typeof selectElement.data('theme') !== 'undefined') {
                sTheme = selectElement.data('theme');
            }
            selectElement.addClass('os-theme--' + sTheme);

            select.on('change', function (e) {
                ooredooSelectSpreedItems(selectWrapper);
                // console.log('change',select)
                if (typeof options.onChange === 'function') {
                    options.onChange(selectWrapper, $(this));
                }
                triggerEvent('change');

            });

            selectedItem.on('click', function (e) {
                toggleItemsVisibility(selectWrapper);
            });

            $('body').on('click', function (e) {
                e.stopPropagation();

                const osParent = $(e.target).closest('.ooredoo-ods-select-wrapper');

                if (selectWrapper.find('.ooredoo-ods-select').hasClass('is-opened')) {
                    if (!osParent.length || !osParent.is(selectWrapper)) {
                        toggleItemsVisibility(selectWrapper);
                    }

                }
            });
        }

        ooredooSelectSpreedItems(selectWrapper);

        resolve(selectWrapper);
    });
}

((($) => {


    $.each($('body').find('select.ods-select'), function (idx, el) {
        ooredooSelect($(el));
    });
})(jQuery));
